document.querySelectorAll( '.biro-block-step-by-step .show-all-steps' ).forEach( function( allButton ) {

  allButton.addEventListener( 'click', function( event ) {

    let allButton = event.currentTarget;

    if ( allButton.getAttribute( 'aria-expanded' ) === 'false' ) {

      allButton.parentNode.querySelectorAll( '.step' ).forEach( function( step ) {
        step.querySelector( '.content' ).style.display = 'block';
        step.querySelector( '.show-hide-text' ).innerHTML = 'Hide';
        step.querySelector( '.step-show' ).setAttribute( 'aria-expanded', 'true' );
      } );

      allButton.querySelector( '.show-all-steps-text' ).innerHTML = 'Hide all steps';
      allButton.setAttribute( 'aria-expanded', 'true' );

    } else {

      allButton.parentNode.querySelectorAll( '.step' ).forEach( function( step ) {
        step.querySelector( '.content' ).style.display = 'none';
        step.querySelector( '.show-hide-text' ).innerHTML = 'Show';
        step.querySelector( '.step-show' ).setAttribute( 'aria-expanded', 'false' );
      } );

      allButton.querySelector( '.show-all-steps-text' ).innerHTML = 'Show all steps';
      allButton.setAttribute( 'aria-expanded', 'false' );

    }

  } );
} );

document.querySelectorAll( '.biro-block-step-by-step .step' ).forEach( function( step ) {

  let heading = step.querySelector( '.heading' );

  heading.innerHTML = '<button class="step-show" aria-expanded="false" aria-controls="' + step.getAttribute( 'id' ) + '-content">' + heading.innerHTML + '</button>';

  let stepShow = step.querySelector( '.step-show' );

  stepShow.addEventListener( 'click', function( event ) {

    if ( stepShow.getAttribute( 'aria-expanded' ) === 'false' ) {

      step.querySelector( '.content' ).style.display = 'block';
      step.querySelector( '.show-hide-text' ).innerHTML = 'Hide';
      stepShow.setAttribute( 'aria-expanded', 'true' );

    } else {

      step.querySelector( '.content' ).style.display = 'none';
      step.querySelector( '.show-hide-text' ).innerHTML = 'Show';
      stepShow.setAttribute( 'aria-expanded', 'false' );

    }

  } );
} );
